import { useCallback, useEffect, useReducer, useState } from 'react'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import * as XLSX from 'xlsx'
import Dropdown from 'react-bootstrap/Dropdown'
import NoDataImg from '../../../assets/img/no-data.gif'
import Form from 'react-bootstrap/Form'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import { v4 as uuidv4 } from 'uuid'
import Box from '@mui/material/Box'
import dayjs, { Dayjs } from 'dayjs'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import InputGroup from 'react-bootstrap/InputGroup'
import Pagination from '@mui/material/Pagination'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateTopHeader,
  updateLoading
} from '../../../redux/features/common/commonSlice'
import AddIcon from '@mui/icons-material/Add'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
import Switch from '@mui/material/Switch'
import { AddCountry } from './AddCountry'
import { data } from 'jquery'
import Utils from '../../constants/Utils'
import { CountryAdsConfiguration } from './CountryAdsConfiguration'
import InsufficientPermission from '../../custom/InSufficientPermission'

// Simple, clean styles with light colors
const customStyles = `
  .country-management-container {
    background: #f8fafc;
    min-height: 100vh;
  }
  
  .country-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    border: 1px solid #e2e8f0;
    overflow: hidden;
  }
  
  .country-header {
    background: white;
    color: #1e293b;
    padding: 24px 30px;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .search-container {
    background: #f8fafc;
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
    border: 1px solid #e2e8f0;
  }
  
  .filter-section {
    background: white;
    border-radius: 6px;
    padding: 16px;
    border: 1px solid #e2e8f0;
  }
  
  .table-container {
    background: white;
    border-radius: 8px;
    margin: 20px;
    overflow: hidden;
    border: 1px solid #e2e8f0;
  }
  
  .country-table {
    margin: 0;
  }
  
  .country-table thead th {
    background: #f1f5f9;
    color: #374151;
    font-weight: 600;
    border: none;
    padding: 16px;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid #e2e8f0;
  }
  
  .country-table tbody tr {
    transition: background-color 0.2s ease;
    border-bottom: 1px solid #f1f5f9;
  }
  
  .country-table tbody tr:hover {
    background: #f8fafc;
  }
  
  .country-table tbody td {
    padding: 16px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f5f9;
  }
  
  .status-badge {
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  
  .status-active {
    background: #dcfce7;
    color: #166534;
  }
  
  .status-inactive {
    background: #fee2e2;
    color: #991b1b;
  }
  
  .country-code-badge {
    background: #eff6ff;
    color: #1e40af;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
  }
  
  .country-flag {
    background: #f3f4f6;
    color: #374151;
    border: 1px solid #d1d5db;
  }
  
  .currency-info {
    background: #fef3c7;
    color: #92400e;
    padding: 6px 10px;
    border-radius: 6px;
    display: inline-block;
    font-weight: 500;
    font-size: 12px;
  }
  
  .action-button {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px;
    color: #374151;
    transition: background-color 0.2s ease;
  }
  
  .action-button:hover {
    background: #e5e7eb;
  }
  
  .action-menu {
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    background: white;
  }
  
  .add-country-btn {
    background: #3b82f6;
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    color: white;
    font-weight: 500;
    font-size: 14px;
    transition: background-color 0.2s ease;
  }
  
  .add-country-btn:hover {
    background: #2563eb;
    color: white;
  }
  
  .filter-btn {
    background: #3b82f6;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: white;
    font-weight: 500;
    transition: background-color 0.2s ease;
  }
  
  .filter-btn:hover {
    background: #2563eb;
    color: white;
  }
  
  .reset-btn {
    background: #6b7280;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    color: white;
    font-weight: 500;
    transition: background-color 0.2s ease;
  }
  
  .reset-btn:hover {
    background: #4b5563;
    color: white;
  }
  
  .search-input {
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 10px 12px;
    font-size: 14px;
    transition: border-color 0.2s ease;
  }
  
  .search-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    outline: none;
  }
  
  .stats-card {
    background: white;
    border-radius: 8px;
    padding: 16px 20px;
    border: 1px solid #e2e8f0;
  }
  
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }
  
  .loading-content {
    background: white;
    border-radius: 8px;
    padding: 30px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  
  .serial-number {
    background: #3b82f6;
    color: white;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
  }
  
  .pagination-container {
    background: #f8fafc;
    border-radius: 8px;
    padding: 20px;
    margin: 20px;
    border: 1px solid #e2e8f0;
  }
  
  .no-data-container {
    background: #f8fafc;
    border-radius: 8px;
    padding: 60px 40px;
    text-align: center;
    margin: 20px;
    border: 1px dashed #cbd5e1;
  }
  
  .label-with-icon {
    color: #374151;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  
  .dropdown-toggle {
    background: white !important;
    border: 1px solid #d1d5db !important;
    border-radius: 6px !important;
    padding: 10px 12px !important;
    color: #374151 !important;
    font-weight: 400 !important;
    transition: border-color 0.2s ease !important;
  }
  
  .dropdown-toggle:hover, .dropdown-toggle:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
  }
  
  .dropdown-menu {
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    padding: 6px !important;
  }
  
  .dropdown-item {
    border-radius: 6px !important;
    padding: 10px 12px !important;
    transition: background-color 0.2s ease !important;
    font-weight: 400 !important;
  }
  
  .dropdown-item:hover {
    background: #f8fafc !important;
    color: #374151 !important;
  }
`;

// Inject styles
if (!document.getElementById('country-list-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'country-list-styles';
  styleSheet.textContent = customStyles;
  document.head.appendChild(styleSheet);
}
const label = { inputProps: { 'aria-label': 'Size switch demo' } }
export const CountryList = props => {
  const { formatDate } = Utils();
  const LOADING_ENABLE = useSelector(state => state?.loading)
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
  const [value, setValue] = useState(dayjs())
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const userData = useSelector(state => state?.userData)
  const [searchText, setSearchText] = useState('')
  const [showAddCountry, setShowAddCountry] = useState(false)
  const [showGlobalConfigModal, setShowGlobalConfigModal] = useState(false)
  const [countryId, setCountryId] = useState('')
  const [datalist, setDatalist] = useState([])
  const [viewPermissionControl, setViewPermissionControl] = useState(false)
  const [viewSubAdminList, setViewSubAdminList] = useState(false)
  const [sort_type, setSortType] = useState('createdAt')
  const [sort_order, setSortOrder] = useState(false)
  const [edit, setEdit] = useState(false)
  const [active, setActive] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [view, setView] = useState(false)
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  })
  const [countryFormData, setCountryFormData] = useState({
    id: '',
    name: '',
    code: '',
    mobileLength: '',
    isnCode: '',
    beadsRate: '',
    bundleGiftServerHost: '',
    bundleGiftServerToken: '',
    bundleProductBased: false,
    currencyCode: '',
    currencySymbol: '',
    currencyName: ''
  })
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedRole, setSelectedRole] = useState({});
  const [callAPi, setCallAPi] = useState('')
  const [data, setData] = useState([])
  const [permissionSubmitData, setPermissionSubmitData] = useState([])
  const [rolePermissionData, setRolePermissionData] = useState({})
  const [subAdminListByRole, setSubAdminListByRole] = useState([])
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const handleChange = (event, value) => {
    setPage(value)
    setPagerecord({
      totalItems: pagerecord?.totalItems,
      totalPages: pagerecord?.totalPages,
      pageNumber: value,
      pageSize: 10
    })
    setCallAPi(uuidv4())
  }

  const handleFilterClick = useCallback(() => {
    setPage(1)
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  }, [searchText, statusDropdownText, startDate, endDate])

  const handleClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setCountryFormData(item);
    setSelectedRole(item); // Fix: Set the selected item for the menu actions
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuEdit = () => {
    handleEditCountry(countryFormData);
    handleClose();
  };

  const handleResetFilter = () => {
    setStartDate(null)
    setEndDate(null)
    setStatusDropdownText('Select Status')
    setSearchText('')
    setPage(1)
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  }
  useEffect(() => {
    dispatch(updateTopHeader('Country Manager'))
  }, [])

  useEffect(() => {
    if (viewPermission) {
      getCountryList()
    }
  }, [callAPi])

  const getGetRolePermssions = async id => {
    try {
      dispatch(updateLoading(true))
      let path = urls.fetchPermission + '/' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        setRolePermissionData(response?.data)
        setViewPermissionControl(true)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleStatusChange = async (event, id) => {
    try {
      dispatch(updateLoading(true))
      let path = urls.changeCountryStatus + '/' + id
      let res = await ApiCaller.put({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getCountryList()
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const getCountryList = async () => {
    let startDateObject
    let endDateObject
    if (startDate?.toDate()) {
      let newDate = new Date(startDate?.toDate())
      newDate.setDate(newDate.getDate() + 1)
      startDateObject = newDate
    }
    if (endDate?.toDate()) {
      let newDate = new Date(endDate?.toDate())
      newDate.setDate(newDate.getDate() + 1)
      endDateObject = newDate
    }
    try {
      dispatch(updateLoading(true))
      let postJson = {
        searchText: searchText?.trim(),
        pageNumber: pagerecord?.pageNumber - 1 || 0,
        pageSize: pagerecord.pageSize || 10,
        shortingField: sort_type,
        asc: sort_order,
        active:
          statusDropdownText === 'Active'
            ? true
            : statusDropdownText === 'In Active'
              ? false
              : null,
        startDate: startDateObject !== null ? startDateObject : '',
        endDate: endDateObject !== null ? endDateObject : ''
      }
      let path = urls.countryList
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        setDatalist(response?.data?.items)
        setPagerecord({
          totalItems: response?.data?.totalItems,
          totalPages: response?.data?.totalPages,
          pageNumber: pagerecord?.pageNumber,
          pageSize: 10
        })
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleEditCountry = item => {
    console.log("item", item)
    setCountryFormData(item)
    setShowAddCountry(true)
  }

  const handleAddCountry = () => {
    setCountryFormData({
      id: '',
      name: '',
      code: '',
      mobileLength: '',
      isnCode: '',
      beadsRate: '',
      bundleGiftServerHost: '',
      bundleGiftServerToken: '',
      bundleProductBased: false,
      currencyCode: '',
      currencySymbol: '',
      currencyName: ''
    })
    setShowAddCountry(true)
  }

  const handleOnSubmitCountryModel = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.addCountry
      let res = await ApiCaller.post(
        countryFormData,
        path,
        userData?.access_token
      )
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getCountryList()
        setShowAddCountry(false)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const submitPermissionControl = async () => {
    try {
      dispatch(updateLoading(true))
      let postData = {
        permissions: permissionSubmitData
      }
      let path = urls.rolePermissionUpdate
      let res = await ApiCaller.post(postData, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        setViewPermissionControl(false)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleImportCountries = async () => {
    try {
      dispatch(updateLoading(true))
      let postJson = {
        dataList: data
      }
      let path = urls.importCountry
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getCountryList()
        setShowAddCountry(false)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if (userPermisiions?.modules.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '15') {
        return element
      }
    })?.permissions
    viewPermission = currentModulePermission.find((element) => {
      if (element.name === 'VIEW') {
        return element
      }
    }).isEnable
    editPermission = currentModulePermission.find((element) => {
      if (element.name === 'EDIT') {
        return element
      }
    }).isEnable
    deletePermissionVal = currentModulePermission.find((element) => {
      if (element.name === 'DELETE') {
        return element
      }
    }).isEnable
    activePermission = currentModulePermission.find((element) => {
      if (element.name === 'ACTIVE') {
        return element
      }
    }).isEnable
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.onload = event => {
      const binaryStr = event.target.result
      const workbook = XLSX.read(binaryStr, { type: 'binary' })

      // Assuming you want to read the first sheet
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]

      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
      let allCountry = []
      jsonData?.map(data => {
        let singleCountry = {
          id: '',
          name: data[0],
          code: '+' + data[2],
          mobileLength: '10',
          isnCode: data[1]
        }
        allCountry.push(singleCountry)
      })
      setData(allCountry)
    }

    reader.readAsBinaryString(file)
  }

  return (
    <>
      <NavBar />
      <div className='main-content country-management-container'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        
        {/* Enhanced Loading Overlay */}
        {LOADING_ENABLE && (
          <div className="loading-overlay">
            <div className="loading-content">
              <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="sr-only">Loading...</span>
              </div>
              <h4 className="text-primary font-weight-bold mb-2">Loading Countries</h4>
              <p className="text-muted mb-0">Please wait while we fetch the latest data...</p>
            </div>
          </div>
        )}

        {viewPermission ? (
          <>
            <div className='container-fluid mt--7'>
              <div className='row justify-content-center'>
                <div className='col-12'>
                  <div className='country-card'>
                    {/* Simple Header */}
                    <div className='country-header'>
                      <div className='row align-items-center'>
                        <div className='col-lg-6'>
                          <div className='d-flex align-items-center'>
                            <div className='mr-3' style={{
                              width: '48px',
                              height: '48px',
                              background: '#f1f5f9',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '1px solid #e2e8f0'
                            }}>
                              <i className='fas fa-globe text-primary' style={{ fontSize: '20px' }}></i>
                            </div>
                            <div>
                              <h2 className='mb-1 font-weight-bold' style={{ fontSize: '1.75rem', color: '#1e293b' }}>
                                Country Management
                              </h2>
                              <p className='mb-0 text-muted' style={{ fontSize: '14px' }}>
                                Manage countries, currencies, and regional settings
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className='col-lg-6'>
                          <div className="d-flex align-items-center justify-content-end">
                            <div className="stats-card mr-3">
                              <div className="d-flex align-items-center">
                                <div className="mr-2">
                                  <i className="fas fa-list-alt text-muted" style={{ fontSize: '16px' }}></i>
                                </div>
                                <div>
                                  <div className="text-muted" style={{ fontSize: '12px' }}>Total</div>
                                  <div className="font-weight-bold text-dark" style={{ fontSize: '18px' }}>
                                    {pagerecord?.totalItems || 0}
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            {(userData.admin || editPermission) && (
                              <button
                                onClick={handleAddCountry}
                                className='add-country-btn'
                              >
                                <i className="fas fa-plus mr-2"></i>
                                Add Country
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Simple Search and Filter Section */}
                    <div className='search-container'>
                      <div className="row">
                        <div className='col-12 mb-3'>
                          <h5 className="font-weight-600 text-dark mb-1">
                            <i className="fas fa-search mr-2 text-primary"></i>
                            Search & Filter
                          </h5>
                          <p className="text-muted mb-0" style={{ fontSize: '14px' }}>Find specific countries using the filters below</p>
                        </div>
                      </div>
                      
                      <div className='row'>
                        <div className='col-lg-4 col-md-6 mb-3'>
                          <div className="filter-section">
                            <label className="form-label text-dark font-weight-500 mb-2">
                              <i className="fas fa-search text-primary mr-2"></i>
                              Search Countries
                            </label>
                            <div className="input-group">
                              <span className="input-group-text bg-primary text-white border-0" style={{ borderRadius: '6px 0 0 6px' }}>
                                <SearchIcon style={{ fontSize: '18px' }} />
                              </span>
                              <input
                                type="text"
                                className="form-control search-input"
                                placeholder="Enter country name..."
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                                style={{ borderLeft: 'none', borderRadius: '0 6px 6px 0' }}
                              />
                            </div>
                          </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-6 mb-3'>
                          <div className="filter-section">
                            <label className="form-label text-dark font-weight-500 mb-2">
                              <i className="fas fa-toggle-on text-success mr-2"></i>
                              Status
                            </label>
                            <Dropdown>
                              <Dropdown.Toggle className="dropdown-toggle w-100 d-flex justify-content-between align-items-center">
                                <span>{statusDropdownText}</span>
                                <i className="fas fa-chevron-down"></i>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu w-100">
                                <Dropdown.Item 
                                  onClick={() => setStatusDropdownText('Select Status')}
                                  className="dropdown-item"
                                >
                                  <i className="fas fa-list mr-2 text-muted"></i>All Status
                                </Dropdown.Item>
                                <Dropdown.Item 
                                  onClick={() => setStatusDropdownText('Active')}
                                  className="dropdown-item"
                                >
                                  <i className="fas fa-check-circle mr-2 text-success"></i>Active
                                </Dropdown.Item>
                                <Dropdown.Item 
                                  onClick={() => setStatusDropdownText('In Active')}
                                  className="dropdown-item"
                                >
                                  <i className="fas fa-times-circle mr-2 text-danger"></i>Inactive
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                        
                        <div className='col-lg-3 col-md-8 mb-3'>
                          <div className="filter-section">
                            <label className="form-label text-dark font-weight-500 mb-2">
                              <i className="fas fa-calendar-alt text-warning mr-2"></i>
                              Date Range
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <div className="d-flex gap-2">
                                <DatePicker
                                  disableFuture
                                  label='From'
                                  value={startDate}
                                  onChange={newValue => setStartDate(newValue)}
                                  maxDate={endDate}
                                  slotProps={{
                                    textField: {
                                      size: 'small',
                                      style: { borderRadius: '6px' }
                                    }
                                  }}
                                />
                                <DatePicker
                                  disableFuture
                                  label='To'
                                  value={endDate}
                                  onChange={newValue => setEndDate(newValue)}
                                  minDate={startDate}
                                  slotProps={{
                                    textField: {
                                      size: 'small',
                                      style: { borderRadius: '6px' }
                                    }
                                  }}
                                />
                              </div>
                            </LocalizationProvider>
                          </div>
                        </div>
                        
                        <div className='col-lg-2 col-md-4 mb-3'>
                          <div className="filter-section">
                            <label className="form-label text-dark font-weight-500 mb-2">
                              Actions
                            </label>
                            <div className="d-flex gap-2">
                              <Button
                                onClick={handleFilterClick}
                                className="filter-btn flex-fill"
                                size="small"
                              >
                                <i className="fas fa-search mr-1"></i>
                                Apply
                              </Button>
                              <Button
                                onClick={handleResetFilter}
                                className="reset-btn flex-fill"
                                size="small"
                              >
                                <i className="fas fa-undo mr-1"></i>
                                Reset
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Simple Table Section */}
                    <div className='table-container'>
                      {datalist && datalist?.length > 0 ? (
                        <>
                          <table className='table country-table mb-0'>
                            <thead>
                              <tr>
                                <th scope='col'>
                                  <i className="fas fa-hashtag mr-1"></i>
                                  #
                                </th>
                                <th scope='col'>
                                  <i className="fas fa-globe mr-1"></i>
                                  Country Details
                                </th>
                                <th scope='col'>
                                  <i className="fas fa-phone mr-1"></i>
                                  Phone Code
                                </th>
                                <th scope='col'>
                                  <i className="fas fa-money-bill-wave mr-1"></i>
                                  Currency
                                </th>
                                <th scope='col'>
                                  <i className="fas fa-calendar mr-1"></i>
                                  Created Date
                                </th>
                                <th scope='col'>
                                  <i className="fas fa-power-off mr-1"></i>
                                  Status
                                </th>
                                {(userData.admin || editPermission) && (
                                  <th scope='col' className="text-center">
                                    <i className="fas fa-tools mr-1"></i>
                                    Actions
                                  </th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {datalist &&
                                datalist?.map((country, i) => {
                                  const startIndex = (pagerecord.pageNumber - 1) * pagerecord.pageSize;
                                  return (
                                    <tr key={country.id}>
                                      <td className="text-center">
                                        <div className="serial-number">
                                          {startIndex + i + 1}
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          <div className="country-flag mr-3" style={{
                                            width: '36px',
                                            height: '24px',
                                            borderRadius: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            letterSpacing: '0.5px'
                                          }}>
                                            {country?.isnCode}
                                          </div>
                                          <div>
                                            <div className="font-weight-600 text-dark" style={{ fontSize: '14px' }}>
                                              {country?.name}
                                            </div>
                                            <small className="text-muted">
                                              ISO: {country?.isnCode}
                                            </small>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <span className="country-code-badge">
                                          <i className="fas fa-phone mr-1"></i>
                                          {country?.code}
                                        </span>
                                      </td>
                                      <td>
                                        <div>
                                          <div className="currency-info mb-1">
                                            <i className="fas fa-coins mr-1"></i>
                                            {country?.currencySymbol} {country?.currencyCode}
                                          </div>
                                          <small className="text-muted">
                                            {country?.currencyName}
                                          </small>
                                        </div>
                                      </td>
                                      <td>
                                        <div>
                                          <span className="font-weight-500 text-dark" style={{ fontSize: '14px' }}>
                                            {formatDate(country?.createdAt)}
                                          </span>
                                          <br />
                                          <small className="text-muted">
                                            <i className="fas fa-clock mr-1"></i>
                                            Registration
                                          </small>
                                        </div>
                                      </td>
                                      <td>
                                        <div className="d-flex align-items-center">
                                          {userData.admin ? (
                                            <Switch
                                              checked={country?.active}
                                              onChange={e => handleStatusChange(e, country?.id)}
                                              size='small'
                                              color="primary"
                                            />
                                          ) : viewPermission ? (
                                            <Switch
                                              checked={country?.active}
                                              disabled={!activePermission}
                                              onChange={e => handleStatusChange(e, country?.id)}
                                              size='small'
                                              color="primary"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          <span className={`ml-2 status-badge ${country?.active ? 'status-active' : 'status-inactive'}`}>
                                            <i className={`fas ${country?.active ? 'fa-check-circle' : 'fa-times-circle'}`}></i>
                                            {country?.active ? 'Active' : 'Inactive'}
                                          </span>
                                        </div>
                                      </td>
                                      {(userData.admin || editPermission) && (
                                        <td className="text-center">
                                          <IconButton 
                                            size="small" 
                                            onClick={(e) => handleClick(e, country)}
                                            className="action-button"
                                          >
                                            <MoreVertIcon />
                                          </IconButton>
                                          <Menu
                                            anchorEl={anchorEl}
                                            open={open && countryFormData?.id === country.id}
                                            onClose={handleClose}
                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                            PaperProps={{
                                              className: 'action-menu',
                                              style: { minWidth: '180px' }
                                            }}
                                          >
                                            {(userData.admin || editPermission) && (
                                              <MenuItem onClick={handleMenuEdit} style={{ padding: '12px 16px' }}>
                                                <i className="fas fa-edit mr-2 text-primary"></i>
                                                <span className="font-weight-500">Edit Country</span>
                                              </MenuItem>
                                            )}
                                            {/* {userData.admin && (
                                              <MenuItem
                                                onClick={() => {
                                                  getGetRolePermssions(selectedRole?.id);
                                                  handleClose();
                                                }}
                                                style={{ padding: '12px 16px' }}
                                              >
                                                <i className="fas fa-shield-alt mr-2 text-warning"></i>
                                                <span className="font-weight-500">Permissions</span>
                                              </MenuItem>
                                            )} */}
                                          </Menu>
                                        </td>
                                      )}
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </>
                      ) : (
                        <>
                          <div className='no-data-container'>
                            <div className="text-center">
                              <img width={'120px'} src={NoDataImg} alt="No Data" style={{ opacity: 0.6 }} />
                              <h4 className="mt-3 font-weight-600 text-muted">
                                {LOADING_ENABLE ? (
                                  <>
                                    <div className="spinner-border text-primary mr-2" role="status" style={{ width: '20px', height: '20px' }}></div>
                                    Loading Countries...
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-search mr-2"></i>
                                    No Countries Found
                                  </>
                                )}
                              </h4>
                              {!LOADING_ENABLE && (
                                <>
                                  <p className="text-muted mb-3" style={{ fontSize: '14px' }}>
                                    No countries match your search criteria.
                                  </p>
                                  <div className="d-flex justify-content-center gap-2">
                                    <button onClick={handleResetFilter} className="filter-btn">
                                      <i className="fas fa-undo mr-1"></i>
                                      Reset Filters
                                    </button>
                                    {(userData.admin || editPermission) && (
                                      <button onClick={handleAddCountry} className="add-country-btn">
                                        <i className="fas fa-plus mr-1"></i>
                                        Add Country
                                      </button>
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                    {/* Simple Pagination */}
                    {datalist && datalist.length > 0 && (
                      <div className='pagination-container'>
                        <div className='d-flex justify-content-between align-items-center flex-wrap'>
                          <div className="d-flex align-items-center mb-2 mb-md-0">
                            <span className="text-muted" style={{ fontSize: '14px' }}>
                              Showing <strong>{((pagerecord.pageNumber - 1) * pagerecord.pageSize) + 1}</strong> to{' '}
                              <strong>{Math.min(pagerecord.pageNumber * pagerecord.pageSize, pagerecord?.totalItems)}</strong> of{' '}
                              <strong>{pagerecord?.totalItems}</strong> countries
                            </span>
                          </div>
                          <Pagination
                            count={pagerecord?.totalPages}
                            page={page}
                            onChange={handleChange}
                            color='primary'
                            size="medium"
                            showFirstButton
                            showLastButton
                            sx={{
                              '& .MuiPaginationItem-root': {
                                borderRadius: '6px',
                                fontWeight: '500',
                                margin: '0 2px',
                                minWidth: '36px',
                                height: '36px',
                                border: '1px solid transparent',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  background: '#f8fafc',
                                  borderColor: '#3b82f6'
                                }
                              },
                              '& .Mui-selected': {
                                background: '#3b82f6 !important',
                                color: 'white !important',
                                borderColor: '#3b82f6',
                                '&:hover': {
                                  background: '#2563eb !important'
                                }
                              },
                              '& .MuiPaginationItem-ellipsis': {
                                color: '#6b7280'
                              }
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            
            {/* Modals */}
            <AddCountry
              show={showAddCountry}
              countryFormData={countryFormData}
              rolePermissionData={rolePermissionData}
              subAdminListByRole={subAdminListByRole}
              setCountryFormData={setCountryFormData}
              onSubmit={() => handleOnSubmitCountryModel()}
              onHide={() => setShowAddCountry(false)}
            />
            <CountryAdsConfiguration
              show={showGlobalConfigModal}
              countryId={countryId}
              onSubmit={() => alert()}
              onHide={() => setShowGlobalConfigModal(false)}
            />
          </>
        ) : (
          <InsufficientPermission />
        )}
      </div>
    </>
  )
}
